import React from 'react';

export default class FixedViewportElement extends React.Component<{children?: React.ReactNode}>{
    scrollPosition: number;
    private static instanceCount: number = 0;
    componentDidMount() {
        this.scrollPosition = window.pageYOffset;
        this.incrementNumberOfOverlays();
        this.toggleFixedViewport();
    }

    componentWillUnmount() {
        this.decrementNumberOfOverlays();
        this.toggleFixedViewport();

        if (this.scrollPosition) {
            window.scrollTo(0, this.scrollPosition);
        }
    }

    incrementNumberOfOverlays() {
        FixedViewportElement.instanceCount++;
    }

    decrementNumberOfOverlays() {
        FixedViewportElement.instanceCount--;
    }

    toggleFixedViewport = () => {
        const fixedViewportActive = FixedViewportElement.instanceCount > 0 ? true : false;

        const body = document.querySelector('body');
        if (body) {
            if (fixedViewportActive) {
                body.setAttribute('data-fixed-viewport-active', 'true');
            } else {
                body.removeAttribute('data-fixed-viewport-active');
            }
        }
    };

    render() {
        return this.props.children;
    }
}
